// src/api/apiClient.js
import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "https://api.imparc.site/",
  headers: {
    "Content-Type": "application/json",
  },
});

// ✅ Request Interceptor — adds token if needed
apiClient.interceptors.request.use(
  (config) => {
    if (config.auth || config.withAuth) {    // <-- check both auth and withAuth
      const token = localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);


// ❌ Optional Response Interceptor — handle expired tokens
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn("Token expired or invalid");
      // e.g., redirect to login page or refresh token
    }
    return Promise.reject(error);
  }
);

export default apiClient;
